module.exports = __webpack_public_path__ + "static/media/galerija_2021 (26)-min.0f4617f5.jpg";